import { axios } from "@/utils/request";

// 获取通知公告
export function getNoticeList(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/yx/notice/list/page",
    method: "get",
    params: params,
  });
}

// 获取通知公告详情
export function getNoticeDetail(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/yx/notice/content",
    method: "get",
    params: params,
  });
}

// 获取QA列表
export function getQAList(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/yx/QA/list/page",
    method: "get",
    params: params,
  });
}

// 获取强制阅读公告
export function getForcedReadingList(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/yx/notice/qzNoReadList",
    method: "get",
    params: params,
  });
}
